<template>
  <div>
        <v-overlay :value="carregandoDadosProfessor"></v-overlay>
        <div class="mt-2" v-if=" msgErro.length >0 || $v.$error">
            <v-alert type="error" dense class="subtitle-2 font-weight-regular">
                <div class="p-1" v-if="msgErro.length > 0">
                    <div  v-for="erro in msgErro" :key="erro">
                        <span v-html="erro"></span> 
                    </div>
                </div>
                <div v-else>>
                    {{ msgErro }}
                </div>
            </v-alert>
        </div>
        <div>
            <v-snackbar
                v-model="snackbar"
                :app="true"
                left
                :timeout="5000"
                color="#198754"
            >
                <div class="p-1" v-if="msg.length > 0">
                    <div  v-for="msg in msg" :key="msg">
                        <span v-html="msg"></span> 
                    </div>
                </div>
                <div v-else>>
                    {{ msg }}
                </div>
            </v-snackbar>
        </div>
        <div class="mt-4 mb-4">
            <div class="row">
                <div class="col-sm-12 col-md-2">
                    <v-text-field 
                    type="text"
                    class="filled-error"
                    label="Ano letivo*" 
                    filled 
                    :error=" ($v.aaletivo.required === false ) && $v.$dirty === true ? true : false"
                    :error-messages=" ($v.aaletivo.required === false ) && $v.$dirty === true ? messages.required : ($v.aaletivo.minLength === false ) && $v.$dirty === true  ? messages.minLength.replace(':min', 4) : '' "
                    background-color="white"
                    min ="4"
                    :maxlength="4"
                    v-mask="'####'"
                    id="aaletivo" 
                    hide-details="auto"
                    v-model.number="aaletivo"
                    >
                    </v-text-field>
                </div>
            </div>
        </div>
        <div>
            
            <v-row class="mb-1"> 
                <v-col class="h6 mb-4" xs="6">
                    Inscrições dos professores
                </v-col>
                <v-col cols="6" xs="12">
                    <div class="text-center d-flex ml-auto justify-end" v-if="inscricoes.length > 0">
                        <v-menu  :close-on-content-click="false" >
                        <template v-slot:activator="{ on, attrs }" >
                            <v-btn
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            >
                            <span >
                                <v-icon small>fas fa-filter</v-icon>
                            </span>
                            </v-btn>
                        </template>
                        <v-list class="p-2" style="background-color: rgb(250,250,250);">
                            <v-list-item>
                                <v-list-item-title>
                                <v-text-field  
                                    filled 
                                    background-color="white"
                                    label="Matrícula"
                                    v-mask="'m######'"  
                                    id="matricula" 
                                    v-debounce:1s="filtrarRanking"
                                    v-model="filtro.matricula" clearable placeholder="m999999"
                                    @focus="filtro.nomeCompleto = '';"
                                ></v-text-field>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title>
                                <v-text-field    
                                    id="nomecompleto" 
                                    filled 
                                    label="Nome completo"
                                    background-color="white"
                                    v-model="filtro.nomeCompleto" 
                                    v-debounce:1s="filtrarRanking"
                                    @focus="filtro.matricula = '';"
                                    clearable @input=" filtro.nomeCompleto = filtro.nomeCompleto.toUpperCase()">

                                </v-text-field>
                                </v-list-item-title>
                            </v-list-item>
                            
                        </v-list>
                        
                        </v-menu>
                    </div>
                </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col md="12">
                <v-data-table
                    :headers="headers"
                    :items="(inscricoesFiltrado.length > 0) ? inscricoesFiltrado : inscricoes"
                    :items-per-page="10"
                    :header-props="headerProps"
                    class="elevation-1"
                    :loading="carregandoDadosTabela"
                    loading-text="Carregando dados. Por favor espere."
                    :footer-props="{
                        'items-per-page-text':'Itens por página',
                        'items-per-page-all-text':  'Todos',
                        'pageText': '{0}-{1} de {2}'
                    }"
                >
                <template slot="no-data">
                    <span style="text-align:center">Nenhum dado para mostrar.</span>
                </template>
                <template v-slot:item.idcargo1="{ item }">
                    <v-icon
                        small
                        color="teal"
                        class="mr-2"
                        v-if="item.idcargo1 === 'S'"
                    >
                        mdi-check-bold
                    </v-icon>
                    <v-icon
                        small
                        color="#E53935"
                        class="mr-2"
                        v-else
                    >
                        mdi-close-thick
                    </v-icon>
                </template>
                <template v-slot:item.idextch="{ item }">
                    <v-icon
                        small
                        color="teal"
                        class="mr-2"
                        v-if="item.idextch === 'S'"
                    >
                        mdi-check-bold
                    </v-icon>
                    <v-icon
                        small
                        color="#E53935"
                        class="mr-2"
                        v-else
                    >
                        mdi-close-thick
                    </v-icon>
                </template>
                <template v-slot:item.idpeb40hs="{ item }">
                    <v-icon
                        small
                        color="teal"
                        class="mr-2"
                        v-if="item.idpeb40hs === 'S'"
                    >
                        mdi-check-bold
                    </v-icon>
                    <v-icon
                        small
                        color="#E53935"
                        class="mr-2"
                        v-else
                    >
                        mdi-close-thick
                    </v-icon>
                </template>
                <template v-slot:item.idacao="{ item }">
                    <v-icon
                        small
                        color="grey"
                        class="mr-2"
                        @click="visualizarDistribuicao(item)"
                    >
                        mdi-eye-outline
                    </v-icon>
                    <!-- <v-icon
                    small
                    @click="deleteItem(item)"
                    >
                    mdi-delete
                    </v-icon> -->
                </template>
                <template v-slot:top>
                    <v-dialog v-model="dialog" max-width="900px">
                        <v-card>
                            <!-- <v-card-title class="p-4" >
                               Distribuição do professor
                            </v-card-title> -->
                            <v-card-text class="p-2">
                                <v-container class="p-4"  >
                                    <v-row no-gutters>
                                        <v-col cols="12" class="p-1">
                                            <v-text-field 
                                                label="Ano letivo"
                                                readonly
                                                filled
                                                v-model="aaletivo">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" lg="3" class="p-1">
                                            <v-text-field 
                                                label="Matrícula"
                                                readonly
                                                filled
                                                v-model="matricula">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="9" class="p-1" >
                                            <v-text-field 
                                                label="Nome"
                                                readonly
                                                filled
                                                v-model="funcionario.nmfuncion">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" lg="3" class="p-1">
                                            <v-text-field 
                                                label="Cargo"
                                                v-if="funcionario.efetivo"
                                                readonly
                                                filled
                                                v-model="funcionario.dscargoef">
                                            </v-text-field>
                                            <v-text-field 
                                                label="Cargo"
                                                v-else
                                                readonly
                                                filled
                                                v-model="funcionario.dscargo">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="9" class="p-1" >
                                            <v-text-field 
                                                label="Especialidade"
                                                readonly
                                                v-if="funcionario.especialidades"
                                                filled
                                                v-model="funcionario.especialidades[0].dsespecia">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" lg="4" class="p-1">
                                            <v-text-field 
                                                label="Situação funcional"
                                                readonly
                                                filled
                                                v-model="situacaoRH.dsafastam">
                                            </v-text-field>
                                        </v-col>
                                        <!-- <v-spacer></v-spacer> -->
                                        <v-col cols="12" lg="4" class="p-1" >
                                            <v-text-field 
                                                label="Total de faltas nos últimos 3 anos"
                                                readonly
                                                filled
                                                v-model="faltas3Anos">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="4" class="p-1" >
                                            <v-text-field 
                                                label="Tempo de extensão"
                                                readonly
                                                filled
                                                v-model="tempoExtensao">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col class="h5" cols="6">Aulas distribuídas</v-col>
                                        <v-col class="h5 text-right" cols="6">
                                            <span>
                                                <v-tooltip top color="#315E7E">
                                                    <!-- <i class="fas fa-bell fa-lg" style=" border-color: 0; color: #E5E5E5;"></i> -->
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                color="grey"
                                                            >mdi-bell</v-icon>
                                                        </template>
                                                    <span>Este é o total de aulas que não possuem justificativa</span>
                                                </v-tooltip> 
                                            </span>
                                            {{`Total de aulas: ${totalDeAulas}`}}
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-data-table
                                                :headers="headersDistribuicao"
                                                :items="distitribuicaoDoProfessor"
                                                :items-per-page="10"
                                                :header-props="headerProps"
                                                class="elevation-1"
                                                :loading="carregandoDadosTabela"
                                                loading-text="Carregando dados. Por favor espere."
                                                :footer-props="{
                                                    'items-per-page-text':'Itens por página',
                                                    'items-per-page-all-text':  'Todos',
                                                    'pageText': '{0}-{1} de {2}'
                                                }"
                                            >
                                                <template v-slot:item.idonline="{ item }">
                                                    <v-icon
                                                        small
                                                        color="teal"
                                                        class="mr-2"
                                                        v-if="item.idonline === 'S'"
                                                    >
                                                        mdi-check-bold
                                                    </v-icon>
                                                    <v-icon
                                                        small
                                                        color="#E53935"
                                                        class="mr-2"
                                                        v-else
                                                    >
                                                        mdi-close-thick
                                                    </v-icon>
                                                </template>
                                            </v-data-table>

                                        </v-col>

                                    </v-row>

                                </v-container>
                                        
                                        <div class="d-flex justify-center">
                                            <span class="ml-4">
                                                <v-btn depressed color="primary" @click="fecharDialog"> Fechar </v-btn>
                                            </span>

                                        </div>
                            </v-card-text>
                        </v-card>

                    </v-dialog>
                </template>


                </v-data-table>
                </v-col>
            </v-row>
        </div>
      
  </div>
</template>

<script>
import Buscar from '../../components/Buscar.vue'
import { mask } from "vue-the-mask"
import distribuicaoOnline from '../../api/distribuicaoOnline'
import { required, minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'


export default {
    name: 'ConsultaInscricoes',
    directives: { mask },
    components: {
        Buscar,
    },

    data() {
        return {
            msgErro: [],
            msg: [],
            matricula: '',
            aaletivo: '',
            inscricoes: [],
            distitribuicaoDoProfessor: [],
            funcionario: [],
            situacaoRH: '',
            tempoExtensao: '',
            faltas3Anos: '',
            carregandoDadosProfessor: false,
            headerProps: {
                sortByText: "Ordernar por"
            },
            headers: [
                        {
                            text: "Matrícula",
                            align: "start",
                            sortable: true,
                            value: "cdmatric",
                        },
                        { text: "Nome", value: "nmfuncion" },
                        { text: "Cargo", value: "dscargo", align: 'center' },
                        { text: "1º cargo", value: "idcargo1", align: 'center' },
                        { text: "Extensão CH", value: "idextch", align: 'center' },
                        { text: "PEB 40Hs", value: "idpeb40hs", align: 'center' },
                        { text: "Justificativa", value: "dsjustifi", align: 'center' },
                        { text: "", value: "idacao" , align: 'center'},
                    ],
            headersDistribuicao: [
                        {
                            text: "Escola",
                            align: "start",
                            sortable: true,
                            value: "nmescola",
                        },
                        { text: "Turno", value: "cnperiodo", align: 'center' },
                        { text: "Etapa Escolar", value: "dsserie", align: 'center' },
                        { text: "Tipo Distribuição", value: "dstpcargo", align: 'center' },
                        { text: "Disciplina", value: "dsdiscipl", align: 'center' },
                        { text: "Justificativa", value: "dsjustifi", align: 'center' },
                        { text: "Quantidade de aulas", value: "qtdaulas", align: 'center' },
                        { text: "Efetivação on-line?", value: "idonline", align: 'center' },
                    ],
            dialog: false,
            carregandoDadosTabela: false,
            justificativasDisponiveis: [
                {cdjustifi: null, dsjustifi: ''},
                {cdjustifi: 14, dsjustifi: 'CEDIDO SEM ONUS'},
                {cdjustifi: 3, dsjustifi: 'COORDENADOR'},
                {cdjustifi: 1, dsjustifi: 'DIRETOR'},
                {cdjustifi: 2, dsjustifi: 'DIRETOR ADJUNTO'},
                {cdjustifi: 4, dsjustifi: 'EQUIPE DIRETIVA DE OUTRA UNIDADE'},
                {cdjustifi: 12, dsjustifi: 'FERIAS PREMIO'},
                {cdjustifi: 15, dsjustifi: 'LIBERADO PARA SINDICATO'},
                {cdjustifi: 11, dsjustifi: 'LICENÇA MATERNIDADE'},
                {cdjustifi: 10, dsjustifi: 'LICENÇA SAÚDE INSS'},
                {cdjustifi: 13, dsjustifi: 'LICENÇA SEM VENCIMENTO'},
                {cdjustifi: 20, dsjustifi: 'REMANEJADO PARA AEE'},
                {cdjustifi: 28, dsjustifi: 'REMANEJADO PARA O CENAM'},
                {cdjustifi: 9, dsjustifi: 'UNIDADES ADMINISTRATIVAS DA SME'},
            ],
            loading: false,
            filtro: {
                matricula: '',
                nomeCompleto: '',
            },
            inscricoesFiltrado: [],

        }
    },
    created() {
      this.aaletivo = this.getAnoLetivo
      
    },
    validations: {
      aaletivo: {required, minLength: minLength(4)},
    },
    watch: {
        aaletivo: async function(newValue, oldValue) {
                if (this.aaletivo > 0){
                    await this.atualizarListaInscricoes()
                }
                else {
                    return []
                }
        },
    },
    computed: {
      ...mapGetters(['getAnoLetivo']),
      snackbar: {
            get() {
                return this.msg.length > 0
            },
            set() {
                return this.msg.length > 0
            }
        },
      totalDeAulas() {
          return this.distitribuicaoDoProfessor.filter((element) => element.cdjustifi === null)
                                                .map((element) => element.qtdaulas)
                                                .reduce((valorAnterior, valorAtual) => valorAnterior + valorAtual, 0)
      }
    },
    methods: {
        async visualizarDistribuicao(item) {
            this.funcionario = []
            this.tempoExtensao = ''
            this.faltas3Anos = ''
            this.matricula = ''
            this.situacaoRH = ''
            
            try {
                this.carregandoDadosProfessor = true
                const {data} = await distribuicaoOnline.listarAulasDistribuidas(item.aaletivo, item.cdpessoal, item.cdmatric1)
                this.distitribuicaoDoProfessor = data.aulasDistribuidas 
                this.funcionario = data.funcionario
                this.tempoExtensao = data.tempoExtensao
                this.faltas3Anos = data.faltas3Anos
                this.matricula = data.matricula
                this.situacaoRH = data.situacaoRH
                this.carregandoDadosProfessor = false
                this.dialog= true
            }
            catch(erro) {
                this.msgErro = erro.response.data.mensagem
                this.loading =false
                this.carregandoDadosProfessor = false

            }
        },
        fecharDialog() {
            this.dialog= false
            this.carregandoDadosProfessor= false
        },
        async atualizarListaInscricoes() {
            this.carregandoDadosTabela = true
            this.inscricoes = []
            this.msg = []
            this.msgErro = []
                try {
                    const {data} = await distribuicaoOnline.pesquisarInscricoes({
                        aaletivo: this.aaletivo
                    })
                    this.inscricoes = data.professores
                    this.carregandoDadosTabela = false
                }
                catch(erro) {
                    this.msgErro = erro.response.data.mensagem
                    this.loading =false
                }

        },
        async salvarInscricao(inscricao) {
            try {
                this.loading =true
                const {data} = await distribuicaoOnline.admCorrigeInscricao(inscricao)
                this.carregandoDadosTabela = true
                await this.atualizarListaInscricoes()
                this.loading =false
                this.carregandoDadosTabela = false
                this.dialog = false 
                this.msg = data.mensagem
            }
            catch(erro) {
                this.dialog = true
                this.msgErro = erro.response.data.mensagem
                this.carregandoDadosTabela = false
                this.loading = false
            }
            
        },
        filtrarRanking() {
        if(this.filtro.matricula) {
           this.inscricoesFiltrado = this.inscricoes.filter(e => e.cdmatric.includes( this.filtro.matricula) )
         }
         else if(this.filtro.nomeCompleto) {
           this.inscricoesFiltrado = this.inscricoes.filter(e => e.nmfuncion.includes( this.filtro.nomeCompleto) )
         }
         else {
           this.inscricoesFiltrado = []
         }
        
      }
    }
}
</script>

<style>

</style>